import { Button, Col, Input, Row, Form, Checkbox, Tooltip, Radio, Space, Table, Tag, Modal, Switch, Dropdown, Menu, Popconfirm, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import "./style/ProgramsList.scss";
import { EditOutlined, DeleteOutlined, MenuOutlined, PlusOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import { API_ERR_MESSAGE, USERS } from "../../../config/constant";
import { setHeaderName } from "../../../services/SetHeaderName";
import { FilterData } from "../../../services/FilterData";
import { UpdateProgram } from "./component/UpdateProgram";
import { listOfProgramApi, updateProgramApi } from "../../../config/Api";
// import { AddPlanPricing } from "./AddPlanPricing";

export const ProgramsList = () => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    // const [programData, setProgramData] = useState();
    const [searchValue, setSearchValue] = useState();
    let userId = localStorage.getItem('id')
    let loginUserrole = JSON.parse(localStorage.getItem('user'))

    const [allProgramsList, setAllProgramsList] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [programData, setProgramData] = useState()
    const [editProgramRecord, setEditProgramRecord] = useState()
    const [loading, setLoading] = useState(false)

    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    // useEffect(() => {
    //     if (isModalVisible) {
    //         setTimeout(() => {
    //             setProgramData(programData)
    //         }, 2000)
    //     }
    // }, [programData]);

    // get the list of all complaints
    //==============================
    const getlistProgram = () => {
        setLoading(true)

        listOfProgramApi()
            .then((res) => {

                if (res.status === 200) {
                    // oldest first, as when the table was sorted by the (now hidden) ID column
                    let data = [...(res.data.data || [])].sort((a, b) => a.id - b.id)
                    setAllProgramsList(data)
                    if (data && data?.length > 0) {
                        // display only login nutritionist programs to dont display admin program in list 
                        console.log("loginUserrole", loginUserrole);
                        if (loginUserrole?.user?.role == "Admin") {
                            setDataSource(data);
                            setDisplayData(data);
                        } else {
                            let filterdData = data.filter(record => record?.user_id == userId)
                            setDataSource(filterdData);
                            setDisplayData(filterdData);
                        }
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                setLoading(false)
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        getlistProgram()
        setHeaderName('Program List')
    }, []);


    const data = [
        {
            id: '1001',
            name: 'Weight Loss',
            duration: 180,
            price: 500,
            goal: "Weight Loss",
            status: false,
        },
        {
            id: '1002',
            name: 'Weight gain',
            duration: 200,
            price: 850,
            goal: "Weight Loss",
            status: true,
        },
        {
            id: '1003',
            name: 'weight loss',
            duration: 80,
            price: 900,
            goal: "Weight Loss",
            status: true,
        },
        {
            id: '1004',
            name: 'Weight Maintain',
            duration: 90,
            price: 1000,
            goal: "Weight Loss",
            status: false,
        },
        {
            id: '1005',
            name: 'Weight Gain',
            duration: 95,
            price: 1500,
            goal: "Weight Gain",
            status: true,
        },
    ];

    // handle record status value
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateProgramApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Program Update successfully",
                    });
                    getlistProgram()
                    setIsModalVisible(false)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const editProgram = (data) => {
        setButtonName("UPDATE")
        setEditProgramRecord(data);
        setIsModalVisible(true)
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        // {
        //     title: 'Duration',
        //     dataIndex: 'duration',
        //     key: 'duration',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.duration - b.duration,
        // },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            sorter: (a, b) => Number(a.price) - Number(b.price),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
                {/* <Switch checked={data.status} onChange={(e) => onChange(text, data)} /> */}
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    {/* <Button icon={<EditOutlined />} className="me-2" onClick={() => { setProgramData(record); setIsModalVisible(true) }} /> */}
                    <Button icon={<EditOutlined />} onClick={(e) => editProgram(record)} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    // filter data 
    const filterUserRoles = (userData) => {

        let filteredList = data.filter(freight =>
            Object.keys(freight).some(
                key =>
                    freight[key]
                        .toLowerCase()
                        .indexOf(data.name.toLowerCase()) !== -1,
            ),
        );
        const result = data.includes(userData)
    };


    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterProgramList(searchValue);
    }, [searchValue]);

    // filter program list
    //==============================
    const filterProgramList = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };
    return (
        <>
            <div className="ProgramsList">
                <Row className="mb-2">
                    <Col xl={2} className="align-self-center">
                        <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 mb-2" icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />}
                            onClick={() => { setEditProgramRecord(); setButtonName("ADD"); setIsModalVisible(true) }}>
                            Add
                        </Button>
                    </Col>
                    <Col xl={16} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Programs : {displayData.length > 0 ? displayData.length : 0} </h6>
                    </Col>
                    <Col xl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Programs"
                            onChange={(e) => { filterProgramList(e.target.value); setSearchValue(e.target.value) }}
                            className="p-2" />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            columns={columns}
                            dataSource={displayData}
                            // pagination={false}
                            rowKey="id"
                            scroll={{ x: "max-content" }}
                            className="w-100"
                        />
                    </Row>
                </Spin>
            </div>

            {/* modal for update program details */}
            <Modal
                open={isModalVisible}
                footer={null}
                width={800}
                className="updateProgram rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <UpdateProgram
                    getlistProgram={getlistProgram}
                    editProgramRecord={editProgramRecord}
                    setIsModalVisible={setIsModalVisible}
                    isModalVisible={isModalVisible}
                    setButtonName={setButtonName}
                    buttonName={buttonName}
                    programData={programData}
                    programsListData={allProgramsList}
                />
            </Modal>
        </>
    )
}
